export default "../css/71ffa2b13d2d5be52bb709487524a3f3.ttf";